import { fetchData } from '../../services/apiClient';
import { API_ENDPOINTS } from '../../services/ApiConfig';

interface MapResponse {
  data: {
    state_date: Record<string, { value: number; value_change: number }>;
    all_data: { value: number; value_change: number };
  };
}

export const fetchMapData = async (payload: any) => {
  return fetchData<MapResponse>(API_ENDPOINTS.SCENARIO_INPUT.FETCH_STATE_METRICS, payload);
};

export const fetchTopologyAPI = async () => {
  const response = await fetch(API_ENDPOINTS.SCENARIO_INPUT.FETCH_TOPOLOGY_FOR_MAP);
  return await response.json();
};
